import script from "./partners.vue?vue&type=script&setup=true&lang=js"
export * from "./partners.vue?vue&type=script&setup=true&lang=js"

import "./partners.vue?vue&type=style&index=0&id=6365b60e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6365b60e"]])

export default __exports__